// extracted by mini-css-extract-plugin
export var pageGradient = "styles-module--pageGradient--ljHil";
export var methodBackgroundClassName = "styles-module--methodBackgroundClassName--TFaIF";
export var priceCardBackgroundClassName = "styles-module--priceCardBackgroundClassName--K-osP";